import FooterLeft from "../footer/FooterLeft";
import FooterContent from "../footer/FooterContent";
import FooterBottom from "../footer/FooterBottom";

import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <FooterLeft />
        <FooterContent />
      </div>
      <FooterBottom />
    </footer>
  );
};

export default Footer;
